import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, withRouter } from 'react-router-dom';

class PublicRoute extends Component {
  componentDidMount() {
    // Check user action to prevent sendPageview on login
    if (this.props.sendPageview && this.props.userAction !== 'login') {
      // Send pageview only if nossa isn't active and the path is not 'identifique-se'
      const blockPageview = this.props.isNossa && this.props.path === '/identifique-se';
      if (!blockPageview) {
        this.props.sendPageview();
      }
    }
  }
  render() {
    return <Route { ...this.props } />;
  }
}

PublicRoute.propTypes = {
  sendPageview: PropTypes.func,
  userAction: PropTypes.string,
  isNossa: PropTypes.bool,
  path: PropTypes.string
};

export default withRouter(PublicRoute);
